const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
const axios = require("axios").default;

export class AuthService {
  static getWpProxyToken() {
    const token = localStorage.getItem("proxyAuthToken");

    if (!token) {
      return undefined;
    } else {
      return token;
    }
  }

  static async getPermissionList(params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/permission/`;
      const response = await axios.get(base_url, {
        params: params,
        headers: {
          //Authorization: `Token ${AuthService.getWpProxyToken()}`,
          Authorization: `Token ${this.getWpProxyToken()}`,
        },
      });
      //console.log(response);
      return response.data;
    } catch (error) {
      console.error(error);
      return error.response;
      //throw error;
    }
  }
}
